module.exports = __webpack_public_path__ + "img/symbol-2.1c89b7a0.svg";